export default {
	tenantId: "axa_hk_ibm_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "axa-ibm--uat"
	}
}
